import React from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { Calendar, Clock, ArrowRight } from 'lucide-react'
import { blogPosts } from '../data/blog'
import VideoPlayer from '../components/VideoPlayer'

const Blog = () => {
  const posts = blogPosts

  return (
    <div className="min-h-screen pt-16">
      <section className="py-20">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-16"
          >
            <h1 className="text-5xl md:text-6xl font-bold mb-6 text-gradient">
              Blog
            </h1>
            <p className="text-xl text-base-content/70 max-w-2xl mx-auto">
              Thoughts, tutorials, and insights on web development, AI, and technology
            </p>
          </motion.div>

          <div className="max-w-4xl mx-auto space-y-8">
            {posts.map((post, index) => (
              <motion.article
                key={post.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ scale: 1.02 }}
                className={`card glass overflow-hidden ${
                  post.featured ? 'border-2 border-primary' : ''
                }`}
              >
                {post.image && (
                  <div className="h-48 overflow-hidden">
                    {post.image.endsWith('.mp4') ? (
                      <VideoPlayer src={post.image} className="h-full" />
                    ) : (
                      <img
                        src={post.image}
                        alt={post.title}
                        className="w-full h-full object-cover"
                      />
                    )}
                  </div>
                )}
                <div className="p-8">
                  {post.featured && (
                    <div className="badge badge-primary mb-4">Featured</div>
                  )}
                  <div className="flex items-center gap-4 text-sm text-base-content/60 mb-4">
                    <span className="badge badge-outline">{post.category}</span>
                    <div className="flex items-center gap-2">
                      <Calendar className="w-4 h-4" />
                      {new Date(post.date).toLocaleDateString()}
                    </div>
                    <div className="flex items-center gap-2">
                      <Clock className="w-4 h-4" />
                      {post.readTime}
                    </div>
                  </div>
                  <h2 className="text-3xl font-bold mb-4">{post.title}</h2>
                  <p className="text-base-content/70 mb-6">{post.excerpt}</p>
                  {post.tags && post.tags.length > 0 && (
                    <div className="flex flex-wrap gap-2 mb-6">
                      {post.tags.map((tag) => (
                        <span key={tag} className="badge badge-outline badge-sm">
                          {tag}
                        </span>
                      ))}
                    </div>
                  )}
                  <Link to={`/blog/${post.id}`} className="btn btn-ghost group">
                    Read More
                    <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                  </Link>
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}

export default Blog
